import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext'; // Corrigido o caminho do contexto
import { useNavigate } from 'react-router-dom';
import styles from './Login.module.css'; // O arquivo CSS deve estar na mesma pasta
import logo from '../assets/images/logo.png';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [totpCode, setTotpCode] = useState('');
  const [show2FA, setShow2FA] = useState(false);
  const [isSetupMode, setIsSetupMode] = useState(false);
  const [setupSecret, setSetupSecret] = useState('');
  const [qrCodeUrl, setQrCodeUrl] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [success, setSuccess] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);
    try {
      const result = await login(username, password, (show2FA || isSetupMode) ? totpCode : undefined, setupSecret);
      
      if (result && result.require2FASetup) {
        setIsSetupMode(true);
        setSetupSecret(result.secret);
        setQrCodeUrl(result.otpauthUrl);
        setIsLoading(false);
        return;
      }

      if (result && result.require2FA) {
        setShow2FA(true);
        setIsLoading(false);
        return;
      }

      setSuccess(`Bem-vindo, ${username}!`);
      setTimeout(() => {
        navigate('/dashboard');
      }, 1500);
    } catch (err) {
      if (err.message === 'REQUIRE_2FA' || err.message.includes('2FA')) {
        setShow2FA(true);
        setError('Código 2FA inválido ou expirado.');
      } else {
        setError(err.message || 'Usuário ou senha incorretos.');
      }
      setIsLoading(false);
    }
  };

  return (
    <div className={styles.loginContainer}>
      <form onSubmit={handleSubmit} className={styles.loginForm}>
        <img src={logo} alt="Bom Jesus" style={{ maxWidth: '250px', display: 'block', margin: '0 auto 20px' }} />
        <h2>Acesso ao Painel</h2>
        <p>
          {!show2FA && !isSetupMode && 'Por favor, insira seu usuário e senha.'}
          {show2FA && !isSetupMode && 'Insira o código do seu Google Authenticator.'}
          {isSetupMode && 'Configure seu Google Authenticator escaneando o QR Code abaixo e insira o código gerado.'}
        </p>
        
        {!show2FA && !isSetupMode ? (
          <>
            <input type="text" value={username} onChange={(e) => setUsername(e.target.value)} placeholder="Usuário" required />
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Senha" required />
          </>
        ) : (
          <>
            {isSetupMode && (
              <div style={{ textAlign: 'center', marginBottom: '15px' }}>
                <img src={`https://api.qrserver.com/v1/create-qr-code/?data=${encodeURIComponent(qrCodeUrl)}&size=200x200`} alt="QR Code 2FA" style={{ border: '2px solid #ccc', borderRadius: '8px' }} />
                <p style={{ fontSize: '0.9rem', color: '#555', marginTop: '10px' }}>Chave manual: <strong style={{ letterSpacing: '2px' }}>{setupSecret}</strong></p>
              </div>
            )}
            <input type="text" value={totpCode} onChange={(e) => setTotpCode(e.target.value)} placeholder="Código (6 dígitos)" required maxLength="6" autoComplete="off" style={{ letterSpacing: '2px', textAlign: 'center', fontSize: '1.2rem' }} />
          </>
        )}

        {error && <p className={styles.error}>{error}</p>}
        {success && <p style={{ color: '#28a745', fontWeight: 'bold', textAlign: 'center' }}>{success}</p>}
        <button type="submit" disabled={isLoading}>
          {isLoading ? 'Entrando...' : 'Entrar'}
        </button>
      </form>
    </div>
  );
};

export default Login;